import { render, staticRenderFns } from "./servicesComponent.vue?vue&type=template&id=575a454a&scoped=true&"
import script from "./servicesComponent.vue?vue&type=script&lang=js&"
export * from "./servicesComponent.vue?vue&type=script&lang=js&"
import style0 from "./servicesComponent.vue?vue&type=style&index=0&id=575a454a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a454a",
  null
  
)

export default component.exports